import { getMegamenuLinkNav } from '@lib/resolveLinkProps';
import useSelector from '@redux/typedHooks';
import { NavLinkDataType } from '../../../types/globalSettingsType';
import { useDocumentUrlWithNode } from './Documents/useDocumentUrl';

interface UseResolvedNavigationLinkOptions {
  data?: NavLinkDataType | null;
  type?: string | null;
  href?: string | null;
  blank?: boolean | null;
  slug?: string | null;
  anchorId?: string | null;
}

const internalLinkTypes = ['internalLink', 'ctaInternalLinkComponent'];

export const useResolvedNavigationLink = ({
  data,
  type,
  href,
  blank,
  slug,
  anchorId,
}: UseResolvedNavigationLinkOptions) => {
  const baseUrl = useSelector((state) => state.application.baseUrl);
  const refUrl = useDocumentUrlWithNode(data, anchorId ?? undefined) || '';
  const linkNav = getMegamenuLinkNav(
    {
      type: type ?? data?.type,
      slug: slug ?? data?.slug,
      blank: Boolean(blank ?? data?.blank),
    },
    baseUrl,
  );
  const isInternal = internalLinkTypes.includes(type ?? '') || linkNav.isInternal;
  const url = isInternal ? refUrl : (href ?? data?.href);

  return {
    isInternal,
    url,
    blank: !isInternal && Boolean(blank ?? data?.blank),
  };
};
